import Sparkline from "./Sparkline";
import InfoButton, { type InfoContent } from "./InfoButton";
import { macroBandTiles } from "../lib/derive";

interface Props {
  info?: InfoContent;
}

export default function MacroBand({ info }: Props) {
  return (
    <div className="macro-band">
      <div className="macro-band-head">
        <div>
          <div className="card-eyebrow">K-141 · K-181 · K-190 · K-192 · ADVANCED</div>
          <div className="macro-band-title">Macro context · feeds the forecast as covariates</div>
        </div>
        {info && <InfoButton info={info} />}
      </div>
      <div className="macro-band-grid">
        {macroBandTiles.map((m) => {
          const sparkDir =
            m.direction === "down" ? "bad" :
            m.direction === "warn" ? "warn" :
            "good";
          return (
            <div key={m.id} className="macro-band-tile">
              <div className="macro-band-tile-id">{m.id}</div>
              <div className="macro-band-tile-name">{m.name}</div>
              <div className="macro-band-tile-row">
                <div className="macro-band-tile-val">{m.val}</div>
                <div className={`macro-band-tile-trend ${m.direction}`}>{m.trend}</div>
              </div>
              <Sparkline
                values={m.spark}
                direction={sparkDir as any}
                className="macro-band-tile-spark"
                viewBox="0 0 200 22"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
